<div *ngIf="this.Workflow" class="outer-div">
    <mat-drawer-container class="drawer-container">
        <div class="mat-drawer-content-div">
            <!-- Define the component's action bar (similar to what is used in the form builder). -->
            <div class="action-bar">
                <!--VNEXT-222: KLW - Set an identifier to be used in the code behind-->
                <div #titleVertical class="workflow-title" style="height:fit-content !important">{{this.Workflow.name}}</div>

                <!-- Define a trash can for deleting workflow states and transitions. -->
                <!--VNEXT-438: KLW - Set object to be hidden when workflow is the default Site-->
                <div *ngIf="!this.ReadOnly"
                     [ngClass]="this.StateOrTransitionBeingDragged ? 'enabled-trash-div' : 'disabled-trash-div'"
                     droppable
                     [dropScope]="['workflowState','workflowTransition']"
                     (onDrop)="this.onObjectDroppedOnTrash($event)">
                    <mat-icon svgIcon="trash"
                              class="trash-mat-icon"
                              matTooltip="{{this.TrashCanTooltip}}"
                              [matTooltipPosition]="this.TooltipPosition"></mat-icon>
                </div>

                <div id="permissionButtonDiv">
                    <button mat-flat-button
                            class="action-item"
                            color="basic"
                            (click)="this.openConfigureRolesDialog($event)">
                        Permissions by Role
                    </button>
                </div>

                <!--VNEXT-438: KLW - Set object to be hidden when workflow is the default Site-->
                <button *ngIf="!this.ReadOnly"
                        mat-flat-button
                        class="action-item"
                        color="basic"
                        (click)="this.workflowSettingsClicked()"
                        matTooltip="{{this.SettingsButtonTooltip}}"
                        [matTooltipPosition]="this.TooltipPosition">
                    <mat-icon aria-hidden="false" aria-label="Form settings">settings</mat-icon>
                </button>

                <button mat-flat-button
                        disabled="{{!Workflow.CurrentUserCanBuildWorkflows}}"
                        class="action-item theme-primary-btn"
                        color="primary"
                        (click)="this.saveWorkflow()"
                        matTooltip="{{this.SaveButtonTooltip}}"
                        [matTooltipPosition]="this.TooltipPosition">
                    <mat-icon aria-hidden="false" aria-label="Save form design">save</mat-icon>
                </button>
            </div>

            <!-- Define the <div/> that contains most of the component's content. -->
            <div class="horizontal-flexbox-div"
                 id="horizontal-flexbox-div">
                <!-- Define two divs/panels, only one of which is shown at any given time. -->
                <div class="builder-tools-and-roles-div">

                    <div id="{{this.BuilderToolsDivId}}"
                         #builderToolsDiv
                         [ngClass]="this.ViewingMode == 'BuilderMode' ? 'shown-builder-tools-div' : 'hidden-builder-tools-div'">
                        <!--(onDragStart)="this.onNewWorkflowStateDragStart($event)"-->
                        <div *ngIf="! this.ReadOnly"
                             draggable
                             [dragScope]="DragScope('workflowState')"
                             [dragData]="null"
                             class="new-workflow-state-div"
                             matTooltip="{{this.PuzzlePieceTooltip}}"
                             [matTooltipPosition]="this.TooltipPosition"
                             (contextmenu)="this.displayBuildContextMenu($event); false;">

                            <button class="workflow-state-button new-state-button"
                                    [ngClass]="{disabled:!Workflow.CurrentUserCanBuildWorkflows}"></button>

                            <div [ngClass]="{disabled:!Workflow.CurrentUserCanBuildWorkflows}" class="new-workflow-state-div">New State</div>
                        </div>
                    </div>

                    <!-- Define context menus. -->
                    <!-- Define the 'Design' context menu. -->
                    <div #buildContextMenuTrigger
                         style="visibility: hidden;
                         position: fixed"
                         [style.left]="this.BuildContextMenuPositionX"
                         [style.top]="this.BuildContextMenuPositionY"
                         [matMenuTriggerFor]="buildContextMenu">
                    </div>
                    <mat-menu #buildContextMenu="matMenu">
                        <button mat-menu-item
                                (click)="this.addNewStateAsFirst($event)">
                            Add State As First
                        </button>
                        <button mat-menu-item
                                (click)="this.addNewStateAsLast($event)">
                            Add State As Last
                        </button>
                    </mat-menu>

                    <!-- Define the 'Permissions' context menu. -->
                    <div #roleContextMenuTrigger
                         style="visibility: hidden;
                         position: fixed"
                         [style.left]="this.RoleContextMenuPositionX"
                         [style.top]="this.RoleContextMenuPositionY"
                         [matMenuTriggerFor]="roleContextMenu">
                    </div>
                    <mat-menu #roleContextMenu="matMenu">
                        <button mat-menu-item
                                (click)="this.openConfigureRolesDialog($event)">
                            Configure Permissions ...
                        </button>
                    </mat-menu>

                </div> <!-- End builder tools and roles div. -->
                <!-- Display/draw workflow states and forward and backward state transitions. -->
                <div class="workflow-states-and-transitions-div">

                    <ng-container *ngIf="this.ShowBackwardTransitionGuidance">
                        <p class="backward-transition-guidance">Drag an outlet icon left to another state to create a backward transition</p>
                    </ng-container>

                    <!-- Display backward workflow transitions. -->
                    <ng-container *ngFor="let workflowTransition of this.BackwardWorkflowTransitions; let iTransition=index">

                        <app-workflow-transition [direction]="'backwards'"
                                                 [workflowTransition]="workflowTransition"
                                                 [workflowStates]="this.ReversedWorkflowStates"
                                                 [viewMode]="this.ViewingMode"
                                                 [dropScope]="['siteRole']"
                                                 [dragScope]="this.DragScope('workflowTransition')"
                                                 [hshWorkflowStatesByClientId]="this.WorkflowStatesByClientId"
                                                 [workflowStatesBeforeTransition]="this.WorkflowStatesBeforeTransition(workflowTransition,false)"
                                                 [workflowStatesAfterTransition]="this.WorkflowStatesAfterTransition(workflowTransition,false)"
                                                 [permissionsPreviewDelayMs]="this.ShowPermissionsPopoversDelaysMs"
                                                 [showPermissionsPreview]="this.ShowTransitionPermissionsPreview"
                                                 (transitionClick)="this.onWorkflowTransitionClicked($event)"
                                                 (dragDropAction)="onTransitionDragDropAction($event)"
                                                 (permissionsSummaryOpened)="this.permissionsPopoverShown(workflowTransition)"
                                                 (permissionsSummaryClosed)="this.permissionsPopoverHidden(workflowTransition)">
                        </app-workflow-transition>
                    </ng-container>

                    <!-- Draw workflow states. -->
                    <div #workflowStatesDiv
                         id="workflow-states-div"
                         class="workflow-states-div shorten-workflow-states-div">

                        <!-- If there are existing workflow states, show them. -->
                        <ng-container *ngFor="let workflowState of this.WorkflowStates; let i=index">

                            <!-- The following div occupies space between workflow state divs. -->
                            <div *ngIf="i == 0"
                                 droppable
                                 [dropScope]="'workflowState'"
                                 (onDrop)="this.onWorkflowStateDroppedBeforeState($event,workflowState)"
                                 class="workflow-state-gap-div"></div>

                            <div droppable
                                 [dropScope]="['siteRole']"
                                 [dropEnabled]="true"
                                 (onDragEnter)="this.onWorkflowStateDragEnter($event,workflowState, i)"
                                 (onDragOver)="this.onWorkflowStateDragOver($event,workflowState, i)"
                                 (onDragLeave)="this.onWorkflowStateDragLeave($event,workflowState, i)"
                                 (onDrop)="this.onItemDroppedOnWorkflowState($event,workflowState, i)"
                                 class="workflow-state-div"
                                 id="workflow-state-div-{{i}}">
                                <ng-container>
                                    <ng-template #workflowStatePopoverTitle><b>{{this.WorkflowStatePermissionsPopoverTitle(workflowState)}}</b></ng-template>
                                    <ng-template #workflowStatePopoverContent>
                                        <ng-container *ngIf="workflowState.PermissionCount == 0">
                                            <p>No permissions defined.</p>
                                        </ng-container>
                                        <ng-container *ngIf="workflowState.PermissionCount > 0">
                                            <table>
                                                <tr>
                                                    <th>Role</th>
                                                    <th>Permissions</th>
                                                </tr>
                                                <ng-container *ngFor="let permissionInfo of workflowState.Permissions">
                                                    <tr *ngIf="this.GetPermissionNames(workflowState, permissionInfo).length > 0">
                                                        <td>{{permissionInfo.roleName}}</td>
                                                        <td>{{this.GetPermissionNames(workflowState, permissionInfo)}}</td>
                                                    </tr>
                                                </ng-container>
                                            </table>
                                        </ng-container>
                                    </ng-template>
                                </ng-container>

                                <!--
                                     Define one of two buttons, either:
                                         1. The button alone that cannot be dragged in 'Permissions' mode; or
                                         2. The draggable button for 'Build' mode.
                                -->
                                <button *ngIf="this.ReadOnly || (this.ViewingMode != this.ViewingModeBuilderMode)"
                                        mat-stroked-button
                                        type="button"
                                        class="{{this.WorkflowStateCssClass(workflowState)}}"
                                        (click)="this.workflowStateClicked($event, workflowState, p)"
                                        matTooltip="{{this.WorkflowStateButtonTooltip(workflowState)}}"
                                        [matTooltipPosition]="this.TooltipPositionAbove"
                                        [popoverTitle]="workflowStatePopoverTitle"
                                        [ngbPopover]="workflowStatePopoverContent"
                                        placement="top"
                                        #p="ngbPopover"
                                        triggers="manual"
                                        (shown)="this.permissionsPopoverShown(workflowState)"
                                        (hidden)="this.permissionsPopoverHidden(workflowState)"
                                        (contextmenu)="this.displayWorkflowStateContextMenu($event, workflowState); false;">
                                    {{workflowState.name}}
                                </button>

                                <button *ngIf="(!this.ReadOnly) && (this.ViewingMode == this.ViewingModeBuilderMode)"
                                        draggable
                                        [dragScope]="DragScope('workflowState')"
                                        [dragData]="workflowState"
                                        (onDragStart)="this.onExistingWorkflowStateDragStart($event,workflowState,i)"
                                        (onDragEnd)="this.onExistingWorkflowStateDragEnd()"
                                        mat-stroked-button
                                        type="button"
                                        class="{{this.WorkflowStateCssClass(workflowState)}}"
                                        (click)="this.workflowStateClicked($event, workflowState, p)"
                                        matTooltip="{{this.WorkflowStateButtonTooltip(workflowState)}}"
                                        [matTooltipPosition]="this.TooltipPositionAbove"
                                        [popoverTitle]="workflowStatePopoverTitle"
                                        [ngbPopover]="workflowStatePopoverContent"
                                        placement="top"
                                        #p="ngbPopover"
                                        triggers="manual"
                                        (shown)="this.permissionsPopoverShown(workflowState)"
                                        (hidden)="this.permissionsPopoverHidden(workflowState)"
                                        (contextmenu)="this.displayWorkflowStateContextMenu($event, workflowState); false;">
                                    <span *ngIf="workflowState.notify">
                                        <mat-icon class="material-icons notify-icon">notifications_active</mat-icon>
                                    </span>
                                    <span *ngIf="!workflowState.notify">
                                        <mat-icon style="opacity: 0.5;" class="material-icons-outlined notify-icon">notifications</mat-icon>
                                    </span>
                                    <span *ngIf="workflowState.showSendNotificationsButton" title="Send Notifications button display for this state">
                                        <mat-icon class="material-icons notify-icon">group</mat-icon>
                                    </span>
                                    <span *ngIf="!workflowState.showSendNotificationsButton" title="Send Notifications button does not display for this state">
                                        <mat-icon style="opacity: 0.5;" class="material-icons-outlined notify-icon">group</mat-icon>
                                    </span>
                                    {{workflowState.name}}
                                </button>
                                <!-- End definition of one of two possible buttons. -->
                                <!--In builder mode, display a draggable plug icon to connect workflows states as a transition. -->
                                <mat-icon *ngIf="(!this.ReadOnly) && (this.ViewingMode == this.ViewingModeBuilderMode)"
                                          svgIcon="plug"
                                          draggable
                                          [dragScope]="DragScope('workflowTransition')"
                                          [dragData]="this.createDraggableWorkflowStateConnector(workflowState)"
                                          (onDragStart)="this.onWorkflowStateConnectorDragStart($event, workflowState, i)"
                                          (onDrag)="this.onWorkflowStateConnectorDrag($event, workflowState, i)"
                                          (onDragEnd)="this.onWorkflowStateConnectorDragEnd($event, workflowState, i)"
                                          class="mat-plug-size"
                                          [ngClass]="(this.WorkflowStates.length > 1) && (! this.isWorkflowStateConnectorTarget(workflowState)) ? 'plug-mat-icon' : 'hidden-plug-mat-icon'"></mat-icon>

                                <!-- When a plug for a state other than this one is being dragged, display a drop area. -->
                                <div droppable
                                     [dropScope]="'workflowTransition'"
                                     (onDrop)="this.onWorkflowStateConnectorDroppedOnWorkflowState($event,workflowState,i)"
                                     [ngClass]="this.isWorkflowStateConnectorTarget(workflowState) ? 'workflow-state-connector-target-div' : 'hidden-workflow-state-connector-target-div'"></div>

                                <div *ngIf="(this.WorkflowStates.length == 1)"
                                     class="one-workflow-state-spacer-div"></div>
                            </div>

                            <!-- The following div occupies space between workflow state divs. -->
                            <div droppable
                                 [dropScope]="'workflowState'"
                                 (onDrop)="this.onWorkflowStateDroppedAfterState($event,workflowState)"
                                 class="workflow-state-gap-div"></div>

                        </ng-container>

                    </div>

                    <!-- Display forward workflow transitions. -->
                    <ng-container *ngIf="this.ShowForwardTransitionGuidance">
                        <p class="forward-transition-guidance">Drag an outlet icon right to another state to create a forward transition</p>
                    </ng-container>

                    <ng-container *ngFor="let workflowTransition of this.ForwardWorkflowTransitions; let iTransition=index">

                        <app-workflow-transition [direction]="'forwards'"
                                                 [workflowTransition]="workflowTransition"
                                                 [workflowStates]="this.WorkflowStates"
                                                 [viewMode]="this.ViewingMode"
                                                 [dropScope]="['siteRole']"
                                                 [dragScope]="this.DragScope('workflowTransition')"
                                                 [hshWorkflowStatesByClientId]="this.WorkflowStatesByClientId"
                                                 [workflowStatesBeforeTransition]="this.WorkflowStatesBeforeTransition(workflowTransition,true)"
                                                 [workflowStatesAfterTransition]="this.WorkflowStatesAfterTransition(workflowTransition,true)"
                                                 [permissionsPreviewDelayMs]="this.ShowPermissionsPopoversDelaysMs"
                                                 [showPermissionsPreview]="this.ShowTransitionPermissionsPreview"
                                                 (transitionClick)="this.onWorkflowTransitionClicked($event)"
                                                 (dragDropAction)="onTransitionDragDropAction($event)"
                                                 (permissionsSummaryOpened)="this.permissionsPopoverShown(workflowTransition)"
                                                 (permissionsSummaryClosed)="this.permissionsPopoverHidden(workflowTransition)">
                        </app-workflow-transition>
                    </ng-container>

                </div> <!-- End workflow states and transitions div. -->

            </div>

        </div>

        <!--//VNEXT-348: KLW - Comment out for now-->
        <div style="visibility: hidden; position: fixed"
             [style.left]="this.WorkflowStateMenuPositionX"
             [style.top]="this.WorkflowStateMenuPositionY"
             [matMenuTriggerFor]="workflowStateContextMenu"
             #workflowStateMenuTrigger>
        </div>

        <mat-menu #workflowStateContextMenu="matMenu">
            <button mat-menu-item
                    (click)="this.contextMenuDeleteState()">
                Delete ...
            </button>
        </mat-menu>


        <mat-drawer #permissionsDrawer
                    mode="over"
                    position="end"
                    class="permissions-drawer"
                    (closedStart)="this.drawerClosing()">
            <form>
                <div id="drawer-keyboard-target-div" tabindex="-1"></div>

                <h4 class="drawer-properties-h4">{{this.PropertiesTitle}}</h4>

                <!--VNEXT-438: KLW - Set object to be hidden when workflow is the default Site-->
                <div *ngIf="(this.HasIdAndName != null && !this.ReadOnly)"
                     class="name-field-div">
                    <mat-form-field appearance="outline"
                                    [floatLabel]="'always'"
                                    class="name-mat-form-field">
                        <mat-label>{{this.NameFieldToEdit}}</mat-label>
                        <input matInput
                               [(ngModel)]="this.NameFieldValue" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="this.nameFieldValueChanged()" />
                    </mat-form-field>


                    <div *ngIf="IdAndNameObjectType=='workflow'" class="padding-left-24">
                        <button mat-icon-button color="primary"
                                class="theme-primary-btn"
                                (click)="this.enableNotificationsAll()"
                                aria-label="Enable notifications for all workflow states">
                            <mat-icon class="material-icons">notification_add</mat-icon>
                        </button>
                        <span> Enable notifications for all workflow states.</span>
                        <div class="spacer"><br /></div>
                        <button mat-icon-button color="primary"
                                class="theme-primary-btn"
                                (click)="this.removeNotificationsAll()"
                                aria-label="Remove notifications for all workflow states">
                            <mat-icon class="material-icons">notifications_off</mat-icon>
                        </button>
                        <span> Remove notifications for all workflow states.</span>
                    </div>
                    <br/>
                    <div *ngIf="IdAndNameObjectType=='workflow'" class="padding-left-24">
                        <button mat-icon-button color="primary"
                                class="theme-primary-btn"
                                (click)="this.enableShowNotifyUsersButtonAll()"
                                aria-label="Enable Send Notifications button for all workflow states">
                            <mat-icon class="material-icons">group</mat-icon>
                        </button>
                        <span> Enable Send Notifications button for all workflow states.</span>
                        <div class="spacer"><br/></div>
                        <button mat-icon-button color="primary"
                                class="theme-primary-btn"
                                (click)="this.removeShowNotifyUsersButtonAll()"
                                aria-label="Hide Send Notifications button for all workflow states">
                            <mat-icon class="material-icons">group_remove</mat-icon>
                        </button>
                        <span> Hide Send Notifications button for all workflow states.</span>
                    </div>
                    <br />

                    <!-- VNEXT-934: KLW - Hide and show properties when using the simple site permissions -->
                    <div class="advanced-settings-accordion" *ngIf="IdAndNameObjectType=='workflow' && !this.ShowOrHidePropertiesForSimplifiedPermissionsModel">
                        <mat-accordion [@.disabled]="true">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Advanced
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="advanced-settings" *ngIf="ShowIsFolderWorkflowCheckbox">
                                    <mat-checkbox [(ngModel)]="this.IsFolderWorkflow" [ngModelOptions]="{standalone: true}">This is a Folder-level Workflow</mat-checkbox>
                                    <div>(Not typical. This is for complex permissions scenarios.)</div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>

                    <!--//VNEXT-310: KLW - Suggest to the user to use a verb-->
                    <!--//VNEXT-348: KLW - Change the description-->
                    <small class="name-tip-small" [innerHTML]="this.NameDescription"></small>
                </div>

                <!--VNEXT-438: KLW - Set object to be hidden when workflow is the default Site-->
                <div *ngIf="(this.HasIdAndName != null) && this.HasWorkflowStateType && !this.ReadOnly">
                    <mat-form-field appearance="fill"
                                    [floatLabel]="'always'"
                                    class="workflow-state-type-form-field">
                        <mat-label>State Type</mat-label>
                        <mat-select [(ngModel)]="this.WorkflowStateTypeId" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="this.workflowStateTypeIdChanged()"
                                    class="workflow-state-type-mat-select">
                            <mat-option *ngFor="let hshStateTypeInfo of this.WorkflowStateTypes"
                                        [value]="hshStateTypeInfo.typeId"
                                        style="height: 60px;">
                                <div class="workflow-state-type-div">
                                    <div class="{{hshStateTypeInfo.colorCssClass}}"></div>
                                    <div class="workflow-state-type-name-div">
                                        <span>{{hshStateTypeInfo.typeName}}</span>
                                    </div>
                                </div>
                            </mat-option>
                        </mat-select>

                    </mat-form-field>
                </div>

                <!--//VNEXT-348: KLW - Changed the description-->
                <!--VNEXT-438: KLW - Set object to be hidden when workflow is the default Site-->
                <div *ngIf="(this.HasIdAndName != null) && this.HasWorkflowTransitionType && !this.IsWorkflow && !this.ReadOnly"
                     class="description-field-div">
                    <!-- Optional description field value. -->
                    <mat-form-field appearance="outline"
                                    [floatLabel]="'always'"
                                    class="description-mat-form-field">
                        <mat-label>Description</mat-label>
                        <textarea matInput
                                  [(ngModel)]="this.DescriptionFieldValue" [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="this.descriptionFieldValueChanged()"></textarea>
                    </mat-form-field>
                    <small class="name-tip-small">The description will be used as the tooltip for the button that represents the action.</small>

                    <!-- Optional replacement worflow transition dialogue title. -->
                    <mat-form-field appearance="outline"
                                    [floatLabel]="'always'"
                                    class="description-mat-form-field">
                        <mat-label>Optional Transition Dialog Title</mat-label>
                        <textarea matInput
                                  [(ngModel)]="this.ChangeWorkflowStateDialogTitle" [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="this.changeWorkflowStateDialogTitleChanged()"></textarea>
                    </mat-form-field>
                    <small class="optional-property-tip-small">Optional custom workflow transition dialog title</small>

                    <!-- Optional replacement worflow transition dialogue message. -->
                    <mat-form-field appearance="outline"
                                    [floatLabel]="'always'"
                                    class="description-mat-form-field">
                        <mat-label>Optional Transition Dialog Message</mat-label>
                        <textarea matInput
                                  [(ngModel)]="this.TransitionConfirmationDialogMessage" [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="this.transitionConfirmationDialogMessagChanged()"></textarea>
                    </mat-form-field>
                    <small class="optional-property-tip-small">Optional custom workflow transition dialog title</small>

                    <!-- Optional "take user to site home page after transition applied" setting. -->
                    <!--[checked]="field.required"-->
                    <!--<mat-label>Take User to Site Home Page After Transition?</mat-label>-->
                    <mat-checkbox [(ngModel)]="this.TakeUserToSiteHomePageAfterTransitionApplied"
                                  (ngModelChange)="this.takeUserToSiteHomePageAfterTransitionAppliedChange()"
                                  name="TakeUserToSiteHomePageAfterTransitionApplied"
                                  class="takeUserToSiteHomePageAfterTransitionApplied-mat-checkbox">Take user to site home page?</mat-checkbox>
                    <small class="optional-property-tip-small">Take user will be brought to site home page transition applied?</small>
                </div>

                <div class="control-wrapper" *ngIf="IdAndNameObjectType!='workflow'">
                    <div>
                        <mat-checkbox class="padding-left-24"
                                      name="chkNotify"
                                      [(ngModel)]="this.WorkflowStateNotify"
                                      [checked]="this.WorkflowStateNotify"
                                      [ngModelOptions]="{standalone: true}"
                                      (ngModelChange)="this.workflowStateNotifyChanged()">
                            <span *ngIf="this.WorkflowStateNotify">
                                <mat-icon class="material-icons notify-icon">notifications_active</mat-icon>
                            </span>
                            <span *ngIf="!this.WorkflowStateNotify">
                                <mat-icon style="opacity: 0.5;" class="material-icons-outlined notify-icon">notifications</mat-icon>
                            </span>

                            Notify
                        </mat-checkbox>
                    </div>
                    <div>
                        <mat-checkbox class="padding-left-24"
                                      name="chkShowSendNotificationsButton"
                                      [(ngModel)]="this.WorkflowStateShowSendNotificationsButton"
                                      [checked]="this.WorkflowStateShowSendNotificationsButton"
                                      [ngModelOptions]="{standalone: true}"
                                      (ngModelChange)="this.workflowStateShowNotifyUsersButtonChanged()">
                            <span *ngIf="this.WorkflowStateShowSendNotificationsButton">
                                <mat-icon class="material-icons notify-icon">group</mat-icon>
                            </span>
                            <span *ngIf="!this.WorkflowStateShowSendNotificationsButton">
                                <mat-icon style="opacity: 0.5;" class="material-icons-outlined notify-icon">group</mat-icon>
                            </span>

                            Show Send Notifications Button on Form
                        </mat-checkbox>
                    </div>
                </div>

                <!--VNEXT-441: KLW - Logic to show the correct Workflow action permission name-->
                <app-workflow-permissions *ngIf="this.HasWorkflowPermissions"
                                          [idAndNameObjectType]="this.IdAndNameObjectType"
                                          [hasWorkflowPermissions]="this.HasWorkflowPermissions"
                                          [actionName]="this.NameFieldValue"
                                          (onClose)="this.closeDrawer($event)"></app-workflow-permissions>


                <div class="properties-buttons-div">
                    <button mat-flat-button color="primary" class="theme-primary-btn" type="submit"
                            (click)="this.savePropertiesClicked()">
                        OK
                    </button>
                    <button mat-flat-button color="basic"
                            (click)="this.cancelPropertiesClicked()">
                        Cancel
                    </button>
                </div>


            </form>
        </mat-drawer>
    </mat-drawer-container>
</div>
